import { combineReducers } from 'redux';

// ** Reducers Imports
import auth from './auth';
import navbar from './navbar';
import layout from './layout';
import ordersConfigs from './ordersConfigs';
import establishment from './establishments';

export const rootReducer = combineReducers({
  auth,
  navbar,
  layout,
  establishment,
  ordersConfigs,
});
